export default __webpack_public_path__ + "static/media/logoGrey.943aa342.png";